import { Edit } from "@mui/icons-material";
import { Avatar, Box, Button, Divider, Icon, Modal, useMediaQuery, useTheme} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ProfileFieldCard } from "../../../components/ProfileFieldCard";
import { PersionalDetails } from "./PersionalDetails";
import { PickupAddress } from "./PickupAddress";
import { BankDetails } from "./BankDetails";
import { BusinessDetails } from "./BusinessDetails";
import ReportIcon from '@mui/icons-material/Report';
import Tooltip from '@mui/material/Tooltip';
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../State/Store";
import { fetchSellerProfile } from "../../../State/seller/sellerSlice";
import { createSelector } from "@reduxjs/toolkit";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
const selectPersonalData = createSelector(
  [(s: RootState) => s.seller.profile],
  (seller) => ({
    mobile: seller?.mobile ?? "",
    sellerName: seller?.sellerName ?? "",
    email: seller?.email ?? "",
  })
);
const selectBusinessDetails = createSelector(
  [(s: RootState) => s.seller.profile],
  (seller) => ({
    businessDetails: seller?.businessDetails ?? null,
    gstin: seller?.gstin ?? "",
  })
);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export const Profile = () => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = React.useState(false);
  const seller = useAppSelector((store) => store.seller);
  const personalData = useAppSelector(selectPersonalData);
  const businessData = useAppSelector(selectBusinessDetails);
  const bankDetails = seller.profile?.bankDetails;
  const pickupAddress = seller.profile?.pickupAddress;
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const dispatch = useAppDispatch();
  const handleClose = () => setOpen(false);
  const [selectedForm, setSelectedForm] = useState("persionalDetails");
  const handleOpen = (formName: string) => {
    setOpen(true);
    setSelectedForm(formName);
  };
  const renderSelectedForm = () => {
    switch (selectedForm) {
      case "persionalDetails":
        return <PersionalDetails {...personalData} />;
      case "pickupAddress":
        return <PickupAddress pickupAddress={pickupAddress} />;
      case "bankDetails":
        return <BankDetails bankDetails={bankDetails} />;
      default:
        return <BusinessDetails {...businessData} />;
    }
  };

  useEffect(() => {
    dispatch(fetchSellerProfile());
  }, [dispatch]);
  // useLayoutEffect(
  //   () => {
  //     if (!rootRef.current) return;
  //     setHeight(rootRef.current.offsetHeight); // or getBoundingClientRect().height
  //   },
  //   [
  //     seller.loading, seller.profile
  //   ]
  // );
  if (seller.loading === true) return null; // or spinner
  if (!businessData) return null;

  return (
    <div className="lg:p-20 pt-3 pb-20  space-y-20">
      <div className="w-full lg:w-[70%]">
       
        <Avatar
          sx={{ width: "10rem", height: "10rem" }}
          src="https://cdn.pixabay.com/photo/2023/09/20/15/47/fish-8265114_1280.jpg"
        />
        <div className="flex items-center pb-5  justify-between items-center">
         <div className="flex justify-around items-center">
         <h1 className="text-2xl py-2 font-bold text-gray-600">
            Personal Details
           
          </h1>
          {seller.profile?.emailVerified==true?(<>
        {
          <VerifiedUserIcon sx={{fontSize:isLarge?"2vw":"5vw"}} color="success"/>
          }
        </>):(<>
        <Tooltip title="Please verify your account by the link sent to your email ">
        <ReportIcon sx={{fontSize:isLarge?"2vw":"5vw"}} color="error"/>
     
    </Tooltip>
        </>)}
         </div>
          <div className="py-2">
            <Button
              sx={{ borderRadius: "2.9rem" }}
              size="small"
              style={{
                minWidth: 0,           // 👈 không cho nó rộng quá
                borderRadius: "999px", // 👈 bo tròn đẹp
                padding:isLarge?"1rem": "2vw",               // padding vừa phải
              }}
              variant="contained"
              onClick={() => {
                handleOpen("persionalDetails");
              }}
            >
              <Edit />
            </Button>
          </div>
          
        </div>
        <div className="space-y-7">
          <div className="">
            <ProfileFieldCard
              keys={"Seller Name"}
              value={seller.profile?.sellerName ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"Seller Email"}
              value={seller.profile?.email ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"Seller Mobile"}
              value={seller.profile?.mobile ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-[70%]">
        <div className="flex items-center pb-3 justify-between">
          <h1 className="text-2xl font-bold text-gray-600">Business Details</h1>
          <div   className="">
            <Button
              sx={{ borderRadius: "10rem" }}
              size="small"
              style={{
                minWidth: 0,           // 👈 không cho nó rộng quá
                borderRadius: "999px", // 👈 bo tròn đẹp
                padding:isLarge?"1rem": "2vw",                  // padding vừa phải
              }}
              className="rounded-lg"
              variant="contained"
              onClick={() => {
                handleOpen("businessDetails");
              }}
            >
              <Edit  />
            </Button>
          </div>
        </div>
        <div className="">
          <div className="">
            <ProfileFieldCard
              keys={"Business Name/ Brand Name"}
              value={
                seller.profile?.businessDetails?.businessName || "Not provided"
              }
            />
            <Divider />
            <ProfileFieldCard
              keys={"GSTIN"}
              value={seller.profile?.gstin || "Not Provided"}
            />
            <Divider />
            <ProfileFieldCard
              keys={"Account Status"}
              value={seller.profile?.accountStatus ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-[70%]">
        <div className="flex items-center pb-3 justify-between">
          <h1 className="text-2xl font-bold text-gray-600">Bank Details</h1>
          <div className="">
            <Button
              sx={{ borderRadius: "2.9rem" }}
              size="small"
              style={{
                minWidth: 0,           // 👈 không cho nó rộng quá
                borderRadius: "999px", // 👈 bo tròn đẹp
                padding:isLarge?"1rem": "2vw",                    // padding vừa phải
              }}
              variant="contained"
              onClick={() => {
                handleOpen("bankDetails");
              }}
            >
              <Edit />
            </Button>
          </div>
        </div>
        <div className="">
          <div className="">
            <ProfileFieldCard
              keys={"Account Holder Name"}
              value={seller.profile?.bankDetails?.accountHolderName ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"Account Number"}
              value={seller.profile?.bankDetails?.accountNumber ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"IFSC CODE"}
              value={seller.profile?.bankDetails?.ifscCode ?? ""}
            />
          </div>
        </div>
      </div>
      <div className="w-full lg:w-[70%]">
        <div className="flex items-center pb-3 justify-between">
          <h1 className="text-2xl font-bold text-gray-600">Pickup Address</h1>
          <div className="">
            <Button
              sx={{ borderRadius: "2.9rem" }}
              size="small"
              style={{
                minWidth: 0,           // 👈 không cho nó rộng quá
                borderRadius: "999px", // 👈 bo tròn đẹp
                padding:isLarge?"1rem": "2vw",                  // padding vừa phải
              }}
              variant="contained"
              onClick={() => {
                handleOpen("pickupAddress");
              }}
            >
              <Edit />
            </Button>
          </div>
        </div>
        <div className="">
          <div className="">
            <ProfileFieldCard
              keys={"Postal Code"}
              value={
                seller.profile?.pickupAddress?.postalCode || "Not provided"
              }
            />
            <ProfileFieldCard
              keys={"Address"}
              value={
                seller.profile?.pickupAddress?.streetName || "Not provided"
              }
            />
            <Divider />
            {/* <ProfileFieldCard keys={"Postal Code"} value={seller.profile?.pickupAddress.postalCode??""} /> */}
            <Divider />
            <ProfileFieldCard
              keys={"Region"}
              value={seller.profile?.pickupAddress?.region ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"City"}
              value={seller.profile?.pickupAddress?.city ?? ""}
            />
            <Divider />
            <ProfileFieldCard
              keys={"Country"}
              value={seller.profile?.pickupAddress?.country ?? ""}
            />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>{renderSelectedForm()}</Box>
      </Modal>
    </div>
  );
};
